export const infrastructureData = {
  title: 'Cloud & Infrastructure',
  subtitle: 'Home Lab & Cloud Infrastructure Experience',
  overview:
    'I design and operate a self-hosted home lab that mirrors real production infrastructure concerns: service isolation, reverse proxy routing, port management, reliability, and privacy-first system choices.',
  services: [
    'Nextcloud deployment with web access over ports 80/443',
    'Pi-hole for network-wide DNS filtering and ad blocking',
    'Multiple services hosted on the same machine with controlled port allocation',
    'Reverse proxy based traffic routing to internal services'
  ],
  competencies: [
    'Local server deployment and lifecycle management',
    'Networking fundamentals: DNS, routing, ports, and request flow',
    'Cloud-like architecture patterns on local infrastructure',
    'Reliability and uptime-oriented operations for always-on services',
    'Privacy-first self-hosted alternatives instead of SaaS defaults'
  ]
};
